export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/48d0057cf54c678c61fc778c0aeda84f.svg";